import { Feedback } from '@modules/Mentor/components/FeedbackModal/FeedbackModal';
import { Meeting } from '@shared/common';
import { Tooltip } from 'antd';
import './meeting-card-buttons.styles.scss';
import { useAnalytics } from 'apps/agora/src/contexts/AnalyticsContext';
import { ANALYTICS_EVENT_NAMES } from 'apps/agora/src/utils/constants';
import { COLORS } from '../../../../../v3/global';

export interface GiveFeedbackButtonProps {
  meeting: Meeting;
  afterSave?: () => void;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  setFeedbackModalData: React.Dispatch<
    React.SetStateAction<{
      id: string;
      feedback: Feedback;
      title: string;
    }>
  >;
}

export interface Explanations {
  explanation0: string;
  explanation1: string;
  explanation2: string;
}

const GiveFeedbackButtonMentor = (props: GiveFeedbackButtonProps) => {
  const { setShowModal, setFeedbackModalData, meeting } = props;

  const { trackEvent } = useAnalytics();

  const giveFeedbackClickHandler = () => {
    setShowModal(true);
    setFeedbackModalData({
      id: meeting._id,
      feedback: {} as Feedback,
      title: `${meeting.enrollment.title}${
        meeting.currentSession ? ` ${meeting.currentSession}` : ''
      } / ${meeting.students[0].fullName}`,
    });
    trackEvent(ANALYTICS_EVENT_NAMES.MEETING_GIVE_FEEDBACK_BUTTON_CLICK);
  };

  return (
    <div>
      <Tooltip
        zIndex={1}
        color="transparent"
        placement="topRight"
        trigger="hover"
        title={
          <div className="feedback-button-tooltip">
            <span
              style={{
                color: COLORS.TEXT_SECONDARY,
              }}
            >
              Give Feedback
            </span>
          </div>
        }
      >
        <span onClick={giveFeedbackClickHandler} className="button-icon-container">
          <div className="feedback-button-icon" />
        </span>
      </Tooltip>
    </div>
  );
};

export default GiveFeedbackButtonMentor;
